import React, {memo, useEffect} from 'react'
import {Button, Dropdown, Grid, Header, Icon, Message, Table, Pagination} from 'semantic-ui-react'
import {
  withBackupsData,
  withErrorHandling,
  withPropsPresent,
  withNavigation,
  withMeData
} from '../../hoc'
import {fromISOString, asOptions, toLocaleString} from '../../util'
import {restoreBackup} from '../../backend'
import {useSafeState} from '../../hook'
import {Paged} from '../shared'

const _Backups = (
  {
    backups,
    backupNames,
    totalBackupsCount,
    navigate,
    location,
    query
  }
) => {

  const getSelectedNames = (query) => {
    const {selectedNames} = query
    if (!selectedNames) {
      return []
    }
    if (typeof selectedNames === 'string') {
      return selectedNames.split(',')
    }
    return selectedNames
  }

  const [state, setState] = useSafeState({
    selectedNames: getSelectedNames(query)
  })

  useEffect(() => {
    setState({...state, selectedNames: getSelectedNames(query)})
    let timeoutId
    if (!!query.restoreSucceeded) {
      timeoutId = setTimeout(() => {
        navigate('/c/account/backups')
      }, 10000)
    }
    return () => {
      if (timeoutId) {
        clearTimeout(timeoutId)
      }
    }
  }, [backups, query])


  const onRestore = async (backupId) => {
    navigate(`/c/account/backups/${backupId}/restore`)
  }

  const onFilterByNames = (e, d) => {
    setState({...state, selectedNames: d.value})
    if (d.value.length) {
      const query = {
        selectedNames: d.value
      }
      return navigate(`/c/account/backups`, {query})
    }
    navigate(`/c/account/backups`)
  }

  const nameOptions = asOptions(backupNames)
  const visibleBackups = state.selectedNames.length ? backups.filter(b => state.selectedNames.includes(b.name)) : backups
  const noItems = (<div>No backups found.</div>)

  return (
    <>
      <Header as='h3'>Backups</Header>
      <Grid>
        {
          !!query.restoreSucceeded && (
            <Grid.Row columns='16'>
              <Grid.Column width='16'>
                <Message positive>
                  <Message.Header>Successfully Submitted Restore Request</Message.Header>
                  <p>
                    Please give this 2-3 minutes and check your services list
                  </p>
                </Message>
              </Grid.Column>
            </Grid.Row>
          )
        }
        <Grid.Row columns='16'>
          <Grid.Column width='16'>
            <Dropdown placeholder='Filter by service name(s)' fluid multiple search selection
                      disabled={nameOptions.length === 0}
                      options={nameOptions}
                      value={state.selectedNames}
                      data-testid='services-filter-dropdown'
                      clearable
                      onChange={onFilterByNames}/>
          </Grid.Column>
        </Grid.Row>
        <Grid.Row columns='16'>
          <Grid.Column width='16'>
            {
              !visibleBackups.length && (
                <div>No backups found. Please wait up to 24 hours to see your first backup</div>
              )
            }
            {
              !!visibleBackups.length && (
                <Paged navigate={navigate} location={location} items={visibleBackups} totalCount={totalBackupsCount}
                       noItemsContent={noItems}
                       render={
                         ({page}) =>
                           <Table>
                             <Table.Header>
                               <Table.Row>
                                 <Table.HeaderCell>Date</Table.HeaderCell>
                                 <Table.HeaderCell>Service</Table.HeaderCell>
                                 <Table.HeaderCell>Restored</Table.HeaderCell>
                                 <Table.HeaderCell></Table.HeaderCell>
                               </Table.Row>
                             </Table.Header>
                             <Table.Body>
                               {
                                 page.map(b => {
                                   return (
                                     <Table.Row key={b.id}>
                                       <Table.Cell
                                         data-test='backup-created'>{toLocaleString(fromISOString(b.createdAt))}</Table.Cell>
                                       <Table.Cell data-test='backup-service'>{b.name}</Table.Cell>
                                       <Table.Cell
                                         data-test='backup-restored'>{`${b.restoreCount} time(s)`}</Table.Cell>
                                       <Table.Cell data-test='backup-created'>
                                         <Button basic size='tiny'
                                                 onClick={() => onRestore(b.id)}
                                                 data-test='backup-restore-action'>
                                           <Icon name='undo'/>
                                           Restore
                                         </Button>
                                       </Table.Cell>
                                     </Table.Row>
                                   )
                                 })
                               }
                             </Table.Body>
                           </Table>
                       }/>
              )
            }
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </>
  )
}

let Backups = (props) => {
  const {handleError} = props
  props = {...props, restoreBackup: handleError(restoreBackup)}
  if (!props.me.activeAccount.backupsEnabled && !(props.me.isSuperUser && props.me.superUserAccount && props.me.superUserAccount.backupsEnabled)) {
    props.navigate('/c/account')
    return null
  }
  return (<_Backups {...props}/>)
}

Backups = withPropsPresent(Backups, ['backups'])
Backups = withBackupsData(Backups, 'Loading backups...')
Backups = withMeData(Backups, 'Loading profile...')
Backups = withNavigation(Backups)
Backups = withErrorHandling(Backups)
Backups = memo(Backups)

export {Backups, _Backups}

export default Backups